import { NgModule } from '@angular/core'
import { UserListComponent } from './user-list/user-list.component'
import { UserDetailsComponent } from './user-details/user-details.component'
import { UserAdministrationsComponent } from './user-administrations/user-administrations.component'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from '../../authentication/auth.guard'
import { UserComponent } from './user.component'
import { SharedModule } from '../../../core/modules/shared.module'
import { UserService } from '../../services/user.service'
import { UsersMainSidenavComponent } from './sidenavs/main/main-sidenav.component'
import { TellowConstants } from '../enums/TellowConstants'
import { AdministrationUsersService } from '../../services/administration-users.service'
import { UsersDetailsSidenavComponent } from './sidenavs/details/details-sidenav.component'
import { RetrievedLoginCredentialsDialogComponent } from './retrieved-login-credentials-dialog/retrieved-login-credentials-dialog.component'

const routes: Routes = [
  {
    path: 'users',
    component: UserListComponent,
    canActivate: [AuthGuard],
    resolve: {
      users: UserService,
    },
  },
  {
    path: 'users/:userId',
    component: UserDetailsComponent,
    canActivate: [AuthGuard],
    resolve: {
      user: UserService,
    },
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes), SharedModule],
  providers: [UserService, AdministrationUsersService, TellowConstants],
  declarations: [
    UserComponent,
    UserListComponent,
    UserDetailsComponent,
    UserAdministrationsComponent,
    UsersMainSidenavComponent,
    UsersDetailsSidenavComponent,
    RetrievedLoginCredentialsDialogComponent,
  ],
  entryComponents: [RetrievedLoginCredentialsDialogComponent],
})
export class UsersModule {}



// WEBPACK FOOTER //
// ./src/app/main/content/users/users.module.ts